<app-spinner-container [isLoading]="ondelete">
    <table 
    matSort 
    (matSortChange)="onSortChange($event)"
      [dataSource]="dataSource"
      mat-table
      
      style="width: 100%"
    >
      <ng-container *ngFor="let column of readColumns" [matColumnDef]="column" >
        <th *matHeaderCellDef mat-header-cell mat-sort-header  >
          {{ labels[column] | translate }}
        </th>
        <td *matCellDef="let type" mat-cell translate >
    {{ type[column] | typedValue | async | translate}}
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell ></th>
        <td *matCellDef="let projet" mat-cell>
          <a (click)="detailprojet(projet)" mat-icon-button>
            <mat-icon style="color: #00a8ff;">info</mat-icon>
          </a>
          
        </td>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
    <app-empty-list-container
                        [list]="dataSource"
                        [withoutBorder]="true"
                ></app-empty-list-container>
  </app-spinner-container>
  <!-- <app-offer [offer]="offer"></app-offer> -->